import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import reportsToInterface from "../../infra/aggregates/reportsToInterface";
// Define a type for the slice state

// Define the initial state using that type
const reportsToData: reportsToInterface = {
  emp_pic: "",
  emp_name: "",
  emp_designation: "",
};

const reportsToSlice = createSlice({
  name: "reportsTo",

  initialState: { reportsToData: reportsToData, reporterRefresh: false },
  reducers: {
    reportsToReducer: (
      state: any,
      action: PayloadAction<reportsToInterface>
    ) => {
      const payload = action.payload;
      state.emp_pic = payload.emp_pic;
      state.emp_name = payload.emp_name;
      state.emp_designation = payload.emp_designation;
    },
    setReporterLoader: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.reporterRefresh = payload;
    },
    resetReportsTo: (state: any) => {
      state.emp_pic = "";
      state.emp_name = "";
      state.emp_designation = "";
    },
  },
});

export const { reportsToReducer, resetReportsTo, setReporterLoader } =
  reportsToSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default reportsToSlice.reducer;
